<template>
  <section class="linkthree-container">
    <div class="container-fluid">
      <div class="columns">
        <div class="column">
          <h2 class="title title-icons">
            <span>CONOCÉ UN POCO MÁS NUESTRA OBRA SOCIAL</span>
          </h2>
        </div>
      </div>
      <ul class="icons">
        <li class="circle">
          <a href="https://www.osfatun.com.ar/planes/">
            <strong>Planes</strong>
          </a>
        </li>
        <li class="circle">
          <a href="https://www.osfatun.com.ar/delegaciones/">
            <strong>Delegaciones</strong>
          </a>
        </li>
        <li class="circle">
          <a href="https://prestadores.osfatun.com.ar/"
            ><strong>Cartilla de prestadores</strong>
          </a>
        </li>
        <li class="circle">
          <a href="https://www.osfatun.com.ar/nosotros/">
            <strong>Sobre<br />OSFATUN</strong>
          </a>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: "LinkThree",
};
</script>

<style scoped>
.linkthree-container {
  margin: 0 auto;
  max-width: 83%;
  padding: 3%;
}

h2.title.title-icons {
  font-weight: bold;
  font-size: 36px;
  text-transform: uppercase;
  color: #00758f;
  width: 100%;
  text-align: center;
  padding: 40px 0;
}
ul.icons {
  display: grid;
  grid-gap: 5px;
  grid-template-columns: auto auto auto auto;
  justify-content: space-evenly;
  width: 100%;
}
ul.icons li {
  /* border: 1px solid #000; */
  color: #000;
  font-weight: lighter;
  display: grid;
  float: left;
  font-size: 20px;
  align-content: center;
  justify-content: center;
  line-height: 1rem;
  position: relative;
  text-align: center;
}
ul.icons li a {
  color: #fff;
  font-size: 16px;
  line-height: 1.3rem;
}
ul.icons li a strong {
  text-transform: uppercase;
}

.circle {
  background: rgb(0, 147, 191);
  background: linear-gradient(
    54deg,
    rgba(0, 147, 191, 1) 0%,
    rgba(0, 117, 143, 1) 100%
  );
  color: #fff;
  display: flexbox;
  padding: 10px;
  border-radius: 100%;
  vertical-align: middle;
  width: 185px;
  height: 185px;
  border: 0;
  position: relative;
}
.circle:hover {
  border: 3px solid #f5a22d;
}
.headerDegraded {
  background: rgb(0, 147, 191);
  background: linear-gradient(
    54deg,
    rgba(0, 147, 191, 1) 0%,
    rgba(0, 117, 143, 1) 100%
  );
}
@media screen and (max-width: 480px) {
  .front-container {
    max-width: 90%;
  }
  h2.title.title-icons {
    padding: 20px 0;
    margin-top: 30px;
  }
  h2.title.title-icons strong {
    display: block;
    font-size: 56px;
  }
  h2.title.title-icons span {
    font-size: 20px;
  }
  .circle {
    width: 150px;
    height: 150px;
    padding: 5px;
  }
  ul.icons {
    overflow: scroll;
    grid-template-columns: auto auto;
  }
}
</style>
